/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Scrollbar, Keyboard, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Box } from "@mui/system";
import { Typography, useMediaQuery } from "@mui/material";
import { MOBLIE_VIEW_WIDTH } from "../../constants/constants";
import AddCircularIcon from "./AddCircularIcon";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState } from "react";

const quickLinkBox = (matchesMob) => css`
  &:hover {
    transform: scale(1.05);
    transition: 0.7s ease;
    ${matchesMob && "opacity: 1;"}
  }
  width: auto;
  height: 88%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #9b9b9b;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  ${matchesMob && "opacity: 0.5;"}
`;

const wrapperBox = css`
  width: auto;
  height: 100%;
  .swiper .swiper-button-prev {
    left: 5px;
    color: aliceblue;
    font-weight: 800;
    overflow: visible;
  }
  .swiper .swiper-button-next {
    right: 5px;
    color: aliceblue;
    font-weight: 800;
  }
`;

export default function MultipleSlidesCarousel({
  industryCardData,
  cardsPerView,
}) {
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState(-1);

  const handleHover = (index) => {
    setVisible(true);
    setValue(index);
  };

  return (
    <>
      <Box p={industryCardData.length < 4 && 1} css={wrapperBox}>
        <Swiper
          modules={[Scrollbar, Keyboard, Navigation, Pagination]}
          grabCursor
          navigation={
            matches
              ? {
                  clickable: true,
                  nextEl: ".swiper-button-next-unique",
                  prevEl: ".swiper-button-prev-unique",
                }
              : false
          }
          keyboard={{ enabled: true }}
          pagination={
            !matches
              ? {
                  el: ".custom-pagination-div",
                  clickable: true,
                  type: "bullets",
                }
              : false
          }
          spaceBetween={10}
          slidesPerView={
            matches ? cardsPerView : industryCardData.length < 4 ? 3 : 3.3
          }
          style={{ height: "100%" }}
        >
          {industryCardData?.map((item, index) => (
            <SwiperSlide
              key={index}
              style={{ height: "100%", overflow: "hidden" }}
            >
              <Box
                css={() => quickLinkBox(matches)}
                p={matches ? 3 : 2}
                style={{
                  backgroundImage: `url(${
                    process.env.REACT_APP_BASEURL +
                    item?.media?.data?.attributes?.url
                  })`,
                }}
                onMouseEnter={() => handleHover(index)}
                onMouseLeave={() => setVisible(false)}
                onClick={() =>
                  !matches && (window.location = "/trucks" + item.buttonLink)
                }
              >
                <Typography
                  style={{
                    opacity: "1",
                    color: "#ffffff",
                  }}
                  variant={matches ? "h4" : "h5"}
                >
                  {item?.title}
                </Typography>
                {matches && visible && value === index && (
                  <AddCircularIcon
                    buttonCss="margin: 0; font-size: small;"
                    handleClick={() =>
                      item?.buttonLink &&
                      (item.isExternalLink
                        ? window.open("/trucks" + item.buttonLink)
                        : (window.location = "/trucks" + item.buttonLink))
                    }
                    buttonText={item?.buttonText}
                    iconCss={{
                      width: "18px",
                      height: "18px",
                      marginRight: "8px",
                      padding: "4px",
                    }}
                  />
                )}
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
        {!matches && <div className="custom-pagination-div" />}
        {matches && (
          <div className="swiper-button-prev-unique">
            <ArrowBackIosIcon style={{ fontSize: "50px" }} />
          </div>
        )}
        {matches && (
          <div className="swiper-button-next-unique">
            <ArrowForwardIosIcon style={{ fontSize: "50px" }} />
          </div>
        )}
      </Box>
    </>
  );
}

MultipleSlidesCarousel.defaultProps = {
  industryCardData: [],
  cardsPerView: 5,
};
